import { render, staticRenderFns } from "./DisplayIDCardStudent.vue?vue&type=template&id=0edbae38&scoped=true&"
import script from "./DisplayIDCardStudent.vue?vue&type=script&lang=js&"
export * from "./DisplayIDCardStudent.vue?vue&type=script&lang=js&"
import style0 from "./DisplayIDCardStudent.vue?vue&type=style&index=0&id=0edbae38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edbae38",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VCard,VIcon,VImg,VRow,VSnackbar,VTab,VTabItem,VTabs,VTabsItems})
